import { observer } from 'mobx-react';
import { Outlet, useLocation } from 'react-router-dom';
import { useStore } from '../../core/utils/hook';
import Footer from './Footer/Footer';
import Header from './Header';
import './style.scss';
import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import { initGA, pageView } from '../../core/utils/gtag';
import { SYSTEM_PATH } from '../../core/configs/constants';
import URL_CONFIG from '../../core/configs/config';
import FooterTopPage from './Footer/FooterTopPage';
import FloatButtonContact from '../Buttons/FloatButtonContact/FloatButtonContact';

export const META_URL = {
    STATIC: [
        { url: SYSTEM_PATH.HOME, title: 'elephamt for Pharmacists　|　研修認定薬剤師の単位取得ができるeラーニングサイト' },
        { url: SYSTEM_PATH.LOGIN, title: 'elephamt for Pharmacists　|　研修認定薬剤師の単位取得ができるeラーニングサイト' },
        { url: SYSTEM_PATH.REGISTRATION_FIRST_STEP, title: 'elephamt for Pharmacists　|　研修認定薬剤師の単位取得ができるeラーニングサイト' },
        { url: SYSTEM_PATH.FORGOT_PASSWORD, title: 'elephamt for Pharmacists　|　研修認定薬剤師の単位取得ができるeラーニングサイト' },
        { url: SYSTEM_PATH.SET_PASSWORD, title: 'elephamt for Pharmacists　|　研修認定薬剤師の単位取得ができるeラーニングサイト' },
        { url: SYSTEM_PATH.STUDENT_GROUP_LIST, title: 'elephamt for Pharmacists　|　受講者リスト' },
        { url: SYSTEM_PATH.COMPANY_TRAINING_LIST, title: 'elephamt for Pharmacists　|　研修一覧' },
        { url: SYSTEM_PATH.INFORMATION_SCREEN, title: 'elephamt for Pharmacists　|　Pharma Info' },
        { url: SYSTEM_PATH.TICKETS, title: 'elephamt for Pharmacists　|　受講プラン一覧' },
        { url: SYSTEM_PATH.PAYMENT, title: 'elephamt for Pharmacists　|　支払い' },
        { url: SYSTEM_PATH.THEMES, title: 'elephamt for Pharmacists　|　講座一覧' },
        { url: SYSTEM_PATH.ATTENDANCE_HISTORY, title: 'elephamt for Pharmacists　|　受講状況（全講座）' },
        { url: SYSTEM_PATH.ATTENDANCE_HISTORY_EI, title: 'elephamt for Pharmacists　|　受講状況EI（全講座）' },
        { url: SYSTEM_PATH.TRAINING_LIST, title: 'elephamt for Pharmacists　|　受講状況（研修指定講座）' },
        { url: SYSTEM_PATH.USER_GUIDE, title: 'elephamt for Pharmacists　|　利用案内' },
        { url: SYSTEM_PATH.FAQ_SCREEN, title: 'elephamt for Pharmacists　|　よくある質問' },
        { url: SYSTEM_PATH.SEND_INQUIRY, title: 'elephamt for Pharmacists　|　お問い合わせ' },
        { url: SYSTEM_PATH.ABOUT_US, title: 'elephamt for Pharmacists　|　運営内容' },
        { url: SYSTEM_PATH.TERM_OF_SERVICE, title: 'elephamt for Pharmacists　|　利用規約' },
        { url: SYSTEM_PATH.PRIVACY_POLICY, title: 'elephamt for Pharmacists　|　個人情報保護方針' },
        { url: SYSTEM_PATH.RECOMMENDED_ENVIRONMENT, title: 'elephamt for Pharmacists　|　推奨環境' },
        { url: SYSTEM_PATH.SPECIFIED_COMMERCIAL_TRANSACTION_LAW_DISPLAY, title: 'elephamt for Pharmacists　|　特定商取引法表示' },
        { url: SYSTEM_PATH.ABOUT_COMPANY, title: 'elephamt for Pharmacists　|　elephamtとは' },
        { url: SYSTEM_PATH.MESSAGES, title: 'elephamt for Pharmacists　|　メッセージ一覧' },
        { url: SYSTEM_PATH.PROFILE, title: 'elephamt for Pharmacists　|　ユーザー情報' },
        { url: SYSTEM_PATH.CHANGE_PASSWORD, title: 'elephamt for Pharmacists　|　パスワード変更' },
        { url: SYSTEM_PATH.ACCOUNT_SETTING, title: 'elephamt for Pharmacists　|　メールニュース受信設定' },
        { url: SYSTEM_PATH.MAIL_SUBSCRIPTION, title: 'elephamt for Pharmacists　|　メールニュース受信設定' },
        { url: SYSTEM_PATH.PURCHASE_HISTORY, title: 'elephamt for Pharmacists　|　購入履歴' },
        { url: SYSTEM_PATH.TOOL_CERTIFICATE, title: 'elephamt for Pharmacists　|　単位管理ツール' },
        { url: SYSTEM_PATH.SHARE_KNOWLEDGE_FILE_LIST, title: 'elephamt for Pharmacists　|　シェアナレッジ' },
        { url: SYSTEM_PATH.SHARE_KNOWLEDGE_REQUEST_LIST, title: 'elephamt for Pharmacists　|　シェアナレッジ' },
        { url: SYSTEM_PATH.SHARE_KNOWLEDGE, title: 'elephamt for Pharmacists　|　シェアナレッジ' },
    ],
    DYNAMIC: [
        { url: SYSTEM_PATH.NOTIFY_DETAIL, title: 'elephamt for Pharmacists　|　<--name-->' },
        { url: SYSTEM_PATH.STUDENT_DETAIL, title: 'elephamt for Pharmacists　|　<--name-->' },
        { url: SYSTEM_PATH.STUDENT_DETAIL_EI, title: 'elephamt for Pharmacists　|　<--name-->' },
        { url: SYSTEM_PATH.INFORMATION_DETAIL, title: 'elephamt for Pharmacists　|　<--name-->' },
        { url: `${SYSTEM_PATH.COURSE_LIST}?themeId=:id`, title: 'elephamt for Pharmacists　|　<--name-->' },
        { url: SYSTEM_PATH.COURSE_DETAIL, title: 'elephamt for Pharmacists　|　<--name-->' },
        { url: `${SYSTEM_PATH.COURSE_DETAIL}/completion-test`, title: 'elephamt for Pharmacists　|　<--name-->　修了テスト' },
        { url: SYSTEM_PATH.LECTURE_DETAIL, title: 'elephamt for Pharmacists　|　<--name-->' },
        { url: SYSTEM_PATH.MESSAGE_DETAIL, title: 'elephamt for Pharmacists　|　<--name-->' }
    ]
};

const META_DEFAULT = {
    title: 'elephamt for Pharmacists　|　研修認定薬剤師の単位取得ができるeラーニングサイト',
    description: '研修認定薬剤師の単位取得ができるeラーニングサイトです。臨床で活かせる知識を学べる講座を豊富に取り揃えています。また、専門学会が提供する専門ジャンルへの入門講座も数多く掲載しています。ぜひ毎年の単位取得ツールとしてご活用ください。'
};


const fetchMetaData = async (key, id) => {
    let metaData;
    // eslint-disable-next-line no-undef
    const http = URL_CONFIG.ssl ? 'https' : 'http';
    const apiurl = `${http}://${URL_CONFIG.api_url}`.replace('/student', '');
    await fetch(`${apiurl}/meta-data?path=${key}&id=${id}`)
        .then(response => response.json())
        .then(data => {
            metaData = data?.data;
        });
    return metaData;
};


const ContainerBody = observer(() => {

    const { authStore: { userInfo } } = useStore();
    const { pathname, search } = useLocation();
    const [metaData, setMetaData] = useState(META_DEFAULT);
    useEffect(() => {
        initGA(); // call initGA to load Google Analytics script
    }, []);

    useEffect(() => {
        const fetchMeta = async () => {
            let newMeta;
            const params = new URLSearchParams(search);
            const themeId = params.get('themeId');

            if (/^\/course\/[^/]+\/completion-test$/.test(pathname)) {
                const matched = META_URL.DYNAMIC.find(item => item.url === `${SYSTEM_PATH.COURSE_DETAIL}/completion-test`);
                if (matched) {
                    const courseId = pathname.split('/')[2];
                    newMeta = {
                        ...matched,
                        title: matched.title.replace('<--name-->', await fetchMetaData(SYSTEM_PATH.COURSE_DETAIL, courseId))
                    };
                }
            }

            // ✅ PRIORITIZE DYNAMIC if themeId is present
            if (themeId) {
                const matched = META_URL.DYNAMIC.find(item => item.url.includes('themeId'));

                if (matched) {
                    newMeta = {
                        ...matched,
                        title: matched.title.replace('<--name-->', await fetchMetaData(matched.url, themeId))
                    };
                }
            }

            // 1. STATIC ROUTE (only if there is no themeId)
            if (!newMeta) {

                newMeta = META_URL.STATIC.find(item => {
                    // exact match
                    if (item.url === pathname) return true;

                    // match pattern: /course/:id/completion-test
                    const isCourseCompletionTest =
                        item.url === '/course/:id/completion-test' &&
                        /^\/course\/[^/]+\/completion-test$/.test(pathname);

                    return isCourseCompletionTest;
                });
            }

            // 2. DYNAMIC ROUTE (if not found yet)
            if (!newMeta) {
                const matched = META_URL.DYNAMIC.find(item => {
                    const urlPrefix = item.url.split('/:')[0];
                    return pathname.startsWith(urlPrefix);
                });

                if (matched) {
                    const dynamicParam = pathname.split('/').pop(); // get the last ID
                    newMeta = {
                        ...matched,
                        title: matched.title.replace('<--name-->', await fetchMetaData(matched.url, dynamicParam))
                    };
                }
            }

            // 3. DEFAULT META
            if (!newMeta) {
                newMeta = META_DEFAULT;
            }

            setMetaData(newMeta);
            pageView(pathname + search, newMeta.title);
        };

        fetchMeta();
    }, [pathname, search]);


    return (
        <>
            <div style={{ position:'relative'}}>
                <Helmet>
                    <title>{metaData.title}</title>
                    <meta name="description" content={metaData.description} />
                </Helmet>
                <Header />
                <div className='wrapper-container' >
                    <div className='wrapper-content'>
                        <Outlet />
                    </div>
                </div>
                {/* <Footer /> */}
                <FooterTopPage />

                <FloatButtonContact />
            </div>
        </>
    )
})

export default ContainerBody;
